/**
 * Overlay global da notificação de conquista.
 *
 * Monta uma vez no `App` (dentro do Router). Liga o detector
 * (`useBadgeUnlockDetector`) e renderiza o banner do topo da fila no
 * canto superior direito — entra deslizando da direita, toca o som e
 * fecha sozinho em ~6s. Clicar leva pra tela de badges do usuário.
 */

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'
import { useTrophyQueue } from '@/hooks/use-trophy-queue'
import { useBadgeUnlockDetector } from '@/hooks/use-badge-unlock-detector'
import { playTrophySound } from '@/lib/play-sound'
import { TrophyBanner } from './TrophyBanner'

export function TrophyNotification() {
  useBadgeUnlockDetector()

  const { current, dismissCurrent } = useTrophyQueue()
  const navigate = useNavigate()
  const reduceMotion = useReducedMotion()

  // Cada troféu novo toca o som. Sem auto-dismiss — o banner fica até o
  // usuário fechar no X ou clicar pra ver as conquistas.
  useEffect(() => {
    if (current) playTrophySound()
  }, [current])

  function handleClick() {
    navigate('/perfil?tab=progress')
    dismissCurrent()
  }

  return (
    <div className="pointer-events-none fixed right-6 top-6 z-[60] flex justify-end">
      <AnimatePresence>
        {current && (
          <motion.div
            key={current.uid}
            initial={reduceMotion ? { opacity: 0 } : { x: '110%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={reduceMotion ? { opacity: 0 } : { x: '110%', opacity: 0 }}
            transition={{ type: 'spring', stiffness: 260, damping: 26 }}
            className="pointer-events-auto"
          >
            <TrophyBanner
              userBadge={current.userBadge}
              onClick={handleClick}
              onClose={dismissCurrent}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
